export default "__VITE_ASSET__dfa3934e__"